import React from 'react';
import type { CustomBenchmarkTypeEnum } from 'venn-api';
import type { DropMenuItem } from 'venn-ui-kit';
import { Icon } from 'venn-ui-kit';
import styled from 'styled-components';

const StyledIcon = styled(Icon)`
  margin-right: 5px;
`;
export const getBenchmarkItems = (hasBlockAssignment = true): DropMenuItem<CustomBenchmarkTypeEnum>[] => [
  ...(hasBlockAssignment ? [] : [{ value: 'NONE' as const, label: 'No Benchmark', icon: <StyledIcon type="ban" /> }]),
  {
    value: 'COMMON' as const,
    label: 'Common Benchmark',
    icon: <StyledIcon type="triangle" />,
  },
  {
    value: 'INDIVIDUAL' as const,
    label: 'Individual Benchmarks',
    icon: <StyledIcon type="shapes" />,
  },
];

export const getBenchmarkTypeText = (customBenchmarkType?: CustomBenchmarkTypeEnum) =>
  customBenchmarkType === 'INDIVIDUAL'
    ? 'Individual Benchmarks'
    : customBenchmarkType === 'COMMON'
      ? 'Common Benchmark'
      : 'None';
